import { Component, OnInit } from '@angular/core';
import { Contact, ContactClient } from 'src/app/services/apis/web-api-client';
import { FileService } from 'src/app/services/file.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent implements OnInit {

  contacts: Contact[] = []
  constructor(
    private contactClient: ContactClient,
    private fileService: FileService
  ) { }

  ngOnInit(): void {
    this.contactClient.getAll().subscribe((contacts) => {
      this.contacts = contacts;
    })
  }
  getImage(id: string) {
    if (id) {
      return this.fileService.getDownloadUrl(id);

    } else {
      return "/assets/user.png"
    }
  }

  getFio(contact: Contact) {
    return contact.surname + ' ' + contact.name + ' ' + contact.fatherName;
  }

}
